<template>
  <div class="container text-with-image-gallery">
    <div class="row text-with-image-gallery__row">
      <div class="col-12 col-md-4 text-with-image-gallery__aside">
        <div v-if="title" class="text-with-image-gallery__title-card">
          <default-title
            class="text-with-image-gallery__title"
            pre_wrap
            :title="title"
            :title_tag="title_tag"/>
        </div>
        <div
          v-if="highlight_title || highlight_content"
          class="text-with-image-gallery__highlight">
          <div
            v-if="highlight_title"
            class="text-with-image-gallery__highlight-title">{{ highlight_title }}</div>
          <html-block
            v-if="highlight_content"
            class="text-with-image-gallery__highlight-content"
            :content="highlight_content"/>
        </div>
      </div>

      <div class="col-12 col-md-8 text-with-image-gallery__gallery">
        <swiper
          :loop="images.length > 1"
          :hide_navigation_buttons="images.length < 2"
          add_navigation_buttons
          prev_btn_class="text-with-image-gallery__prev"
          next_btn_class="text-with-image-gallery__next">
          <swiper-slide
            v-for="(image, index) in images"
            :key="`gallery-image_${index}_${uid}`">
            <lazy-image
              class="text-with-image-gallery__image"
              cover_img
              :src="image.image_src"
              :lazy_src="image.image_lazy_src"
              :alt="`gallery_${index}`"/>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import LazyImage from "../small_parts/LazyImage.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import uid_mixin from "../../mixins/uid_mixin";

export default {
  name: "TextWithImageGallery",
  mixins: [uid_mixin],
  components: {
    SwiperSlide,
    Swiper,
    DefaultTitle,
    LazyImage,
    HtmlBlock
  },
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    title_tag: {
      type: String,
      default: 'h2',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    highlight_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    highlight_content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    images: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        image_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        image_lazy_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
      }
    },
    /**props**/
  }
}
</script>
